import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input } from "antd";
import moment from "moment";
import usaFlag from "../../assets/images/footer/united-states-flag.png";
import indiaFlag from "../../assets/images/footer/indian-flag.png";
import {
  sendMailAlert,
  resetMailAlert,
} from "../../actionCreator/commonActionCreator";
import { msgEnum } from "../../config";
const ContactForm = () => {
  const dispatch = useDispatch();
  const mailAlertInfo = useSelector(
    (state) => state?.CommonReducer?.mailAlertInfo,
  );
  const formIntialValue = {
    name: { disabled: true, value: "", status: null },
    phone: { disabled: true, value: "", status: null },
    email: { disabled: true, value: "", status: null },
    message: { disabled: true, value: "", status: null },
  };
  const [errorObj, setError] = useState();
  const [form, setForm] = useState(formIntialValue);
  const [contactUsMsg, setContactUsMsg] = useState("");
  useEffect(() => {
    setForm(formIntialValue);
  }, []);
  useEffect(() => {
    if (Object.keys(mailAlertInfo).length) {
      setContactUsMsg(msgEnum.CONTACT_FORM_SUCCESS_MSG);
      setForm(formIntialValue);
      dispatch(resetMailAlert());
    }
  }, [mailAlertInfo]);
  const onInputChange = (ele) => {
    setForm({
      ...form,
      [ele.target.name]: { ...form[ele.target.name], value: ele.target.value },
    });
  };
  const contactUsFormSubmit = () => {
    let errObj = {};
    if (!form.name.value) {
      errObj = {
        ...errObj,
        name: "Please enter name.",
      };
    }
    if (!form.phone.value) {
      errObj = {
        ...errObj,
        phone: "Please enter phone.",
      };
    }
    if (!form.email.value) {
      errObj = {
        ...errObj,
        email: "Please enter email.",
      };
    }
    if (!form.message.value) {
      errObj = {
        ...errObj,
        message: "Please enter message.",
        status: "error",
      };
    }
    setError(errObj);
    if (!Object.keys(errObj).length) {
      let todayDate = moment().utc().format(" MMM DD, YYYY");
      const payload = {
        accountId: "0",
        description: form.message.value,
        fotter: todayDate,
        from: "",
        //"id": 0,
        subject: form.name.value,
        title: form.phone.value,
        toEmail: form.email.value,
        type: "CONTACTUS",
        userId: "ANONYMOUS",
      };
      //console.log(payload,'payload')
      dispatch(sendMailAlert(payload));
    }
  };
  return (
    <>
      <div className="w3l-contact-info" id="contact">
        <div className="container py-md-5 py-4">
          {/* <div className="align-self">
            <div className="contact-infos">
              <div className="single-contact-infos">
                <div className="icon-box">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="text-box">
                  <h3 className="mb10 roboto-regular">Address info</h3>
                  <p className="roboto-regular mb10"> <span className="fw-semibold"><img src={usaFlag} alt="USA Flag" className="img-responsive" style={{ height: '30px' }} /></span>&nbsp; 99 Wall Street #3639
                    New York, NY 10005</p>
                  <p className="roboto-regular"><span className="fw-semibold"><img src={indiaFlag} alt="Indian Flag" className="img-responsive" style={{ height: '30px' }} /></span>&nbsp; 401, Radhakrishna Building, Banjara Hills Hyderabad, Telangana 500034</p>
                </div>
              </div>
              <div className="single-contact-infos">
                <div className="icon-box">
                  <i className="fas fa-clock"></i>
                </div>
                <div className="text-box">
                  <h3 className="mb10 roboto-regular">Opening hours</h3>
                  <p className="roboto-regular"> Monday – Friday : 9am - 6pm</p>
                  <p className="roboto-regular"> Saturday : 10am - 4pm</p>
                </div>
              </div>
              <div className="single-contact-infos">
                <div className="icon-box">
                  <i className="fas fa-envelope-open-text"></i>
                </div>
                <div className="text-box">
                  <h3 className="mb10 roboto-regular">Contact info</h3>
                  <p className="roboto-regular">
                    <a href="tel:+91-9625-981200">+91-9625-981200</a>
                  </p>
                  <p className="roboto-regular">
                    <a href="mailto:contact@beyondleadz.ai">
                      contact@beyondleadz.ai
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row mt-5 pt-md-5">
            {/* <div className="col-lg-6 map order-lg-1 order-2">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3024.600441859405!2d-74.00971192450196!3d40.7047966380575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a161aaa68c5%3A0x3f3eefe7829c03d1!2s99%20Wall%20St%20%233639%2C%20New%20York%2C%20NY%2010005%2C%20USA!5e0!3m2!1sen!2sin!4v1750753888473!5m2!1sen!2sin"
                frameborder="0"
                allowfullscreen=""
                height="700"
                title="map"
                className="locationMap"
              ></iframe>
            </div> */}
            <div className="col-lg-12 form-inner-cont order-lg-2 order-1 mb-lg-0 mb-5">
              <iframe
                src="w2l-forms/contactForm.html"
                title="Contact Us form"
                frameborder="0"
                width="100%"
                height="649px"
              ></iframe>

              {/* <div className="signin-form">
                <div
                  style={{
                    marginBottom: 20,
                    textAlign: "center",
                    verticalAlign: "center",
                  }}
                >
                  <span style={{ color: "#02AA02", fontSize: 18 }}>
                    {contactUsMsg}
                  </span>
                </div>

                <div className="form-input">
                  <Input
                    name="name"
                    value={form?.name?.value}
                    placeholder="Your Name"
                    onChange={onInputChange}
                  />
                  <div className="errorTxt roboto-regular heading13px">
                    {errorObj?.name}
                  </div>
                </div>
                <div className="form-input">
                  <Input
                    name="phone"
                    value={form?.phone?.value}
                    placeholder="Your Phone Number"
                    onChange={onInputChange}
                  />
                  <div className="errorTxt roboto-regular heading13px">
                    {errorObj?.phone}
                  </div>
                </div>
                <div className="form-input">
                  <Input
                    name="email"
                    value={form?.email?.value}
                    placeholder="Your Email Address"
                    onChange={onInputChange}
                  />
                  <div className="errorTxt roboto-regular heading13px">
                    {errorObj?.email}
                  </div>
                </div>
                <div className="form-input">
                  <textarea
                    name="message"
                    value={form?.message?.value}
                    placeholder="Your message"
                    onChange={onInputChange}
                  ></textarea>
                  <div className="errorTxt roboto-regular heading13px">
                    {errorObj?.message}
                  </div>
                </div>
                <div className="text-right">
                  <button
                    type="submit"
                    className="common-btn-class main-btn-primary roboto-regular"
                    onClick={contactUsFormSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactForm;
